import * as S from '@effect/schema/Schema';
export var PrivacyPolicyBlockConfig = S.struct({
  typename: S.literal('PrivacyPolicyBlock'),
  id: S.string,
  hash: S.string,
  body: S.nullable(S.string)
});